<template>
    <div :class="['page approve',{ off: !pageOn }]">
        <!-- <VHeader type="back" @back="pageOn = false" /> -->
        <VHeader type="ham" @ham="on = true;" />
        <Ham :on="on" @select="hamSelect" />
        <div class="page-content">
            <div class="approve-item">
                <p>{{ approve.message }}</p>
                <img :src="approve.ad_src" />
            </div>
            <div v-if="!approve.approved">
                <p class="btn" @click="approveAd(approve)">APPROVE</p>
                <p class="btn" @click="pushPage('feedback')">FEEDBACK</p>
            </div>
            <p v-else class="btn" style="background-color: tomato">APPROVED</p>
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapMutations } from 'vuex'
import Alert from '@/utils/Alert.js'
import Ham from '@/components/Ham.vue'

export default {
    name: 'approve',
    mixins: [ pageOn ],
    components: {
        VHeader,
        Ham
    },
    props: ['approve'],
    data () {
        return {
            on: false,
            paySuccess: false,
            payFailed: false
        }
    },
    mounted () {
        
    },
    methods: {
        hamSelect ( page ) {
            this.on = false;
            this.pushPage(page);
            if ( page == 'terms' ) {
                this.$emit('showTerms');
            }
        },
        approveAd ( approve ) {
            if ( approve.price > 0 ) return this.pay(approve.price)
            WebSoc.SEND({ t: 'adApprove', data: { approve_id: approve._id, ad_id: approve.ad_id, client_id: approve.client_id }},resp => {
                Alert.message('This Ad has now been approved');
                this.approve.approved = true;
            })
        },
        pay ( price ) {
            var that = this;
            this.$emit('payRequest',{
                amount: price,
                client_id: this.approve.client_id,
                ad_id: this.approve.ad_id,
                approve_id: this.approve._id,
                complete ( resp ) {
                    if ( resp.success ) {
                        that.payFailed = false;
                        that.approve.approved = true;
                        that.paySuccess = { amount: price }
                        Alert.message('This Ad has now been approved');
                    } else {
                        that.paySuccess = false;
                        that.payFailed = true;
                    }
                    
                }
            })
        },
        ...mapMutations([
            'pushPage'
        ])
    }
}

</script>

<style lang="scss">
.page.approve {
    .approve-item {
        > p { text-align: center; margin-top: 10px; }
        img { width: 70%; margin: 10px 0px 10px 15%; }
    }
}
</style>